import React from 'react';
import vars from '../../utils/vars';
import Button from '../button';
import {handleUnauthorizedRequest} from '../../actions/validateSession';
import req from '../../../shared/req';

const LogoutButton = (): React.ReactElement => {
  if (vars.isSPA) {
    return (
      <Button
        onClick={async () => {
          req({url: '/logout'}).finally(handleUnauthorizedRequest);
        }}
        outline
        className="log-out-button btn-margin-top"
      >
        Log out
      </Button>
    );
  } else {
    return (
      <a
        href="/logout"
        key="logout"
        className="shared-button medium blue-outline log-out-button btn-margin-top"
      >
        Log out
      </a>
    );
  }
};

export default LogoutButton;
